export default __webpack_public_path__ + "static/media/web-project-2.f0108702.jpg";